// extracted by mini-css-extract-plugin
export default {"card":"U4-z"};